import { MultiValue } from 'react-select'

interface Option {
  value: string
  label: string
}

/** Vacío = todas. 1 = sí. 0 = no. */
export type ExportFlagFilter = '' | '0' | '1'

export interface ExportFiltrosType {
  states: MultiValue<Option>
  store_name: MultiValue<Option>
  payment_method: MultiValue<Option>
  destination: MultiValue<Option>
  transportadora: MultiValue<Option>
  dateRange: { start: string; end: string }
  id_market: string
  sku: string
  listo_fe: ExportFlagFilter
  fe_generada: ExportFlagFilter
}

const setFlagQueryParam = (
  queryParams: URLSearchParams,
  key: 'listo_fe' | 'fe_generada',
  value: ExportFlagFilter
) => {
  if (value === '0' || value === '1') {
    queryParams.set(key, value)
  }
}

/**
 * Construye los query params para la API basado en los filtros
 */
export const buildQueryParams = (filtros: ExportFiltrosType, page: number = 1): URLSearchParams => {
  const queryParams = new URLSearchParams()
  queryParams.set('limit', '80')
  queryParams.set('page', page.toString())

  // Agregar filtros multi-select
  if (filtros.states.length > 0) {
    queryParams.set('states', filtros.states.map(item => item.value).join(','))
  }
  if (filtros.store_name.length > 0) {
    queryParams.set('stores', filtros.store_name.map(item => item.value).join(','))
  }
  if (filtros.payment_method.length > 0) {
    queryParams.set('paymentMethod', filtros.payment_method.map(item => item.value).join(','))
  }
  if (filtros.destination.length > 0) {
    queryParams.set('destino_pedido', filtros.destination.map(item => item.value).join(','))
  }
  if (filtros.transportadora.length > 0) {
    queryParams.set('transportadora', filtros.transportadora.map(item => item.value).join(','))
  }

  // Agregar rango de fechas
  if (filtros.dateRange.start && filtros.dateRange.end) {
    queryParams.set('startDate', filtros.dateRange.start)
    queryParams.set('endDate', filtros.dateRange.end)
  }

  if (filtros.id_market) {
    queryParams.set('id_market', filtros.id_market)
  }

  const sku = filtros.sku.trim()
  if (sku) {
    queryParams.set('sku', sku)
  }

  setFlagQueryParam(queryParams, 'listo_fe', filtros.listo_fe)
  setFlagQueryParam(queryParams, 'fe_generada', filtros.fe_generada)

  return queryParams
}

/**
 * Formatea la fecha para el nombre del archivo Excel
 */
export const formatDateForFileName = (): string => {
  const now = new Date()
  return now
    .toISOString()
    .replace(/T/, '_')
    .replace(/\..+/, '')
    .replace(/:/g, '-')
}

